<template>
  <transition name="box-anim" v-if="visible" v-on:after-leave="afterLeaveBoxAnim">
    <div class="tweet-box">
      <div class="root" @click="showDetail" :style="{
        backgroundColor: mainColor
      }">
        <div class="img" :style="{
          backgroundImage:`url('${dispSrc}')`
        }">
          <div class="errmsg-box" v-if="errmsg">
            <div class="errmsg">
              {{ errmsg }}
            </div>
          </div>
        </div>
        <div class="cols">
          <colorset-mini-view :colorset="colorset"></colorset-mini-view>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .tweet-box {
    height: 100%;
    overflow: hidden;
    border: 0.5px solid white;
  }
  .errmsg-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .errmsg {
    font-size: 10pt;
    text-align: center;
    width: 100%;
    padding-top: 1em;
    color: gray;
  }
  .img {
    width: 100%;
    height: calc(100% - 29px);
    display: block;
    background-size: cover;
    background-position: center;
  }
  .cols {
    bottom: 0;
    height: 30px;
    width: 100%;
  }
  .root {
    width: 100%;
    height: 100%;
    background-color: white;
  }

  .box-anim-enter-active {
    transition: all .3s ease;
  }
  .box-anim-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .box-anim-enter, .box-anim-leave-to {
    transform: translateY(20px) scale(0.8);
    opacity: 0;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>

<script>
import ColorAnalyzerApi from '@/api/ColorAnalyzerApi'
import Colorset from '@/models/Colorset'
import ColorsetMiniView from '@/components/ColorsetMiniView'

export default {
  name: 'TweetBox',
  components: {ColorsetMiniView},
  props: {
    imgsrc: String,
    visible: Boolean,
    statusid: String,
    mindex: Number,
    stockid: String
  },
  data () {
    return {
      colorCount: 5,
      colorset: new Colorset(),
      stockImgsrc: null,
      errmsg: null
    }
  },
  computed: {
    dispSrc () {
      return this.visible ? this.$props.imgsrc : null
    },
    mainColor () {
      const cs = this.$data.colorset
      const item = cs ? cs.itemAt(0) : null
      return item ? this.itemCssColor(item) : '#fff'
    }
  },
  methods: {
    async imgChanged (newsrc) {
      if (!newsrc) { return }
      this.$data.errmsg = null
      try {
        this.$data.colorset = await ColorAnalyzerApi.colorsetFromUrl(newsrc, this.$data.colorCount)
      } catch (err) {
        this.$data.errmsg = 'Tweet not found.'
      }
    },
    showDetail () {
      this.$router.push(this.stockid
        ? `/stock/${this.stockid}`
        : `/status/${this.statusid}/${this.mindex}`)
    },
    itemCssColor (colorItem) {
      const rgb = colorItem.c
      return '#' + rgb.map(v => Math.floor(v).toString(16).padStart(2, '0')).join('')
    },
    afterLeaveBoxAnim (el) {}
  },
  watch: {
    dispSrc (newVal) {
      if (!newVal) {
        return
      }
      this.imgChanged(newVal)
    }
  },
  mounted () {
    this.imgChanged(this.dispSrc)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TweetBox.vue